import { useSelector } from "react-redux";
import { SLICE_AUTH } from "src/redux-app/slices";
import { EstadosApisDtSourceImplRest } from "../../data/datasources/EstadosApisDtSourceImplRest";
import { EstadosApisRepositoryImpl } from "../../data/repositories/EstadosApisRepositoryImpl";
import { GetEstadosApisUseCase } from "../../bussines/useCases/GetEstadosApisUseCase";
import { executeUseCase } from "src/views/core/helpers/executeUseCase";
import { GetEstadosApisTransporteUseCase } from "../../bussines/useCases/GetEstadosApisTransporteUseCase";

export const useEstadosApis = () => {
    const apikey: string | undefined = useSelector((state: any) => state[SLICE_AUTH].usuario.key);
    const conceptosDtSourceGql = new EstadosApisDtSourceImplRest(apikey ?? '');
    const repository = new EstadosApisRepositoryImpl(conceptosDtSourceGql);
    const getEstadosApis = async () => {
        const useCase = new GetEstadosApisUseCase(repository);
        const result = await executeUseCase({ input: null , useCase });
        return result;
    }
    const getEstadosApisTransporte = async () => {
        const useCase = new GetEstadosApisTransporteUseCase(repository);
        const result = await executeUseCase({ input: null , useCase });
        return result;
    }
    return { getEstadosApis, getEstadosApisTransporte };
}